/*
 * fe-discount-autoapply v2 —— 站内折扣码静默套用。两条触发路径共用一个套码函数：
 *   路径一（自 2026-08-22，#21）：点到站内 /discount/ 链接 → 拦截跳转，后台 fetch 套码。
 *   路径二（v2，#41）：Shopify Forms 弹窗进入成功屏 → 零点击自动套码，成功屏里的链接原地改成已激活态。
 * 成功判定：只认 /cart.js 的 discount_codes 里真有这个码（修 v1 把 429/挑战页当成功的缺陷）。
 * 请求预算：空车 1 次（/discount/CODE?redirect=/cart.js 跟随跳转直接拿购物车 JSON）；非空车 2 次（再 POST /cart/update.js 取抽屉 HTML）。
 * 非空车：Shrine 自家写法 renderContents(state, true) 只替换抽屉内容、不打开抽屉（打开会被 #37 连带藏掉成功屏）。
 *         刷新失败：点击路径退回整页 reload；自动路径不打断成功屏，码已在车上，下次换页即显示。
 * 依赖 Forms 内部结构的只有三个常量：宿主标签、#app-embed、data-current-step="success"。任一失效 → 路径二静默不触发，路径一照常。
 * 防重复：sessionStorage 记已套过的码；同页内存状态 pending/done/failed，自动路径失败后不自动重试。
 * 试运行开关 ZERO_CLICK：false 时不启动路径二（成功屏回到「点一下」），路径一不受影响。2026-10-09 CC 裁决先开启试运行。
 */
(function () {
  'use strict';

  var ZERO_CLICK = true;  // 试运行开关：true = 成功屏零点击自动套码；false = 退回「点一下」
  var DONE_TEXT_CART  = '✓ Code appliqué à votre panier';
  var DONE_TEXT_EMPTY = '✓ Code activé pour votre panier';
  var STORE_PREFIX = 'fe-discount-applied:';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LINK_HOSTS = [location.hostname, 'floraencore.com', 'www.floraencore.com'];
  var FORMS_HOST_TAG = 'shopify-forms-embed';  // 依赖点 1
  var STEP_SELECTOR = '#app-embed';            // 依赖点 2
  var STEP_ATTR = 'data-current-step';         // 依赖点 3
  var STEP_SUCCESS = 'success';

  var state = {};    // 小写码 -> 'pending' | 'done' | 'failed'
  var pending = {};  // 小写码 -> Promise<cart>
  var lastCart = {}; // 小写码 -> 套码时的 item_count（决定已激活文案用哪条）
  var api = window.feDiscountAutoapply = { version: 2, zeroClick: ZERO_CLICK, state: state, log: [] };
  function note(m) { try { api.log.push(new Date().toISOString().slice(11, 19) + ' ' + m); if (api.log.length > 40) api.log.shift(); } catch (e) {} }
  function key(c) { return String(c || '').toLowerCase(); }

  // ---------- 识别折扣链接 ----------
  function codeFromHref(href, sameOriginOnly) {
    if (!href) return null;
    try {
      var u = new URL(href, location.href);
      if (sameOriginOnly ? u.origin !== location.origin : LINK_HOSTS.indexOf(u.hostname) === -1) return null;
      var m = u.pathname.match(/\/discount\/([^\/]+)\/?$/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }
  function isDiscountLink(node) {
    return !!(node && node.nodeType === 1 && node.tagName === 'A' && codeFromHref(node.getAttribute('href'), true));
  }
  function findDiscountLink(event) {            // shadow DOM 只能靠 composedPath
    if (typeof event.composedPath === 'function') {
      var path = event.composedPath();
      for (var i = 0; i < path.length; i++) if (isDiscountLink(path[i])) return path[i];
    }
    var t = event.target, hit = t && t.closest ? t.closest('a[href*="/discount/"]') : null;
    return isDiscountLink(hit) ? hit : null;
  }
  function linksIn(root, code) {
    var out = [], all = root.querySelectorAll('a[href]');
    for (var i = 0; i < all.length; i++) {
      var c = codeFromHref(all[i].getAttribute('href'), false);
      if (c && (!code || key(c) === key(code))) out.push(all[i]);
    }
    return out;
  }

  // ---------- 会话记忆 ----------
  function wasApplied(code) { try { return sessionStorage.getItem(STORE_PREFIX + key(code)) === '1'; } catch (e) { return false; } }
  function remember(code) { try { sessionStorage.setItem(STORE_PREFIX + key(code), '1'); } catch (e) {} }
  function isDone(code) { return state[key(code)] === 'done' || wasApplied(code); }

  // ---------- 网络 ----------
  function asJson(res) {
    if (!res.ok) throw new Error('http ' + res.status);
    return res.json().catch(function () { throw new Error('not-json'); });
  }
  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(asJson);
  }
  function cartHas(cart, code) {
    var list = cart && cart.discount_codes;
    if (!Array.isArray(list)) return false;
    for (var i = 0; i < list.length; i++) if (list[i] && key(list[i].code) === key(code)) return true;
    return false;
  }
  function applyCode(code) {
    var k = key(code);
    if (pending[k]) return pending[k];
    state[k] = 'pending';
    note('apply ' + code);
    var url = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'cart.js');
    var p = fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('http ' + res.status);
        return res.text().then(function (t) { try { return JSON.parse(t); } catch (e) { return getCart(); } });
      })
      .then(function (cart) {
        if (!cartHas(cart, code)) throw new Error('code-missing');
        state[k] = 'done'; remember(code); lastCart[k] = cart.item_count || 0;
        note('applied, item_count=' + cart.item_count);
        return cart;
      });
    pending[k] = p;
    p.catch(function (e) { state[k] = 'failed'; delete pending[k]; note('apply failed: ' + (e && e.message)); });
    return p;
  }

  // ---------- 购物车刷新 ----------
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return Promise.reject(new Error('no-drawer'));
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
    }).then(asJson).then(function (s) {
      if (!s || !s.sections || !s.sections['cart-drawer']) throw new Error('no-sections');
      drawer.renderContents(s, true);    // true = 只换内容不打开
      note('drawer refreshed');
    });
  }
  var HANG = function () { return new Promise(function () {}); };
  function afterApplied(cart, mode) {         // mode: 'click' | 'auto'
    if (!cart || !cart.item_count) return Promise.resolve();
    if (onCartPage()) { location.reload(); return HANG(); }
    return refreshDrawer().catch(function (e) {
      note('refresh failed: ' + e.message);
      if (mode === 'click') { location.reload(); return HANG(); }
    });
  }

  function markDone(link, code) {
    if (!link || link.getAttribute('data-fe-discount') === 'done') return;
    link.setAttribute('data-fe-discount', 'done');
    link.removeAttribute('aria-busy'); link.removeAttribute('href'); link.removeAttribute('target');
    link.textContent = (lastCart[key(code)] > 0) ? DONE_TEXT_CART : DONE_TEXT_EMPTY;
    link.style.cursor = 'default'; link.style.textDecoration = 'none';
  }

  // ---------- 路径一：点击（先注册，保证路径二初始化出错时退路仍在） ----------
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = findDiscountLink(event);
    if (!link) return;
    var href = link.getAttribute('href');
    var code = codeFromHref(href, true);
    var fallback = new URL(href, location.href).href;
    event.preventDefault();
    link.setAttribute('aria-busy', 'true');
    applyCode(code)
      .then(function (cart) { return afterApplied(cart, 'click'); })
      .then(function () { markDone(link, code); })
      .catch(function () { link.removeAttribute('aria-busy'); location.href = fallback; });
  }, true);

  // ---------- 路径二：Forms 成功屏零点击 ----------
  function evaluate(root) {
    var app = root.querySelector(STEP_SELECTOR);
    if (!app || app.getAttribute(STEP_ATTR) !== STEP_SUCCESS) return;
    var links = linksIn(root, null);
    if (!links.length) return;
    var code = codeFromHref(links[0].getAttribute('href'), false);
    var k = key(code);
    if (isDone(code)) { links.forEach(function (a) { markDone(a, code); }); return; }
    if (state[k]) return;                        // pending 等结果；failed 本页不自动重试
    links.forEach(function (a) { a.setAttribute('aria-busy', 'true'); });
    applyCode(code)
      .then(function (cart) { return afterApplied(cart, 'auto'); })
      .then(function () { linksIn(root, code).forEach(function (a) { markDone(a, code); }); })
      .catch(function () { linksIn(root, code).forEach(function (a) { a.removeAttribute('aria-busy'); }); });
  }
  function watchRoot(root) {
    if (!root || root.__feWatched) return;
    root.__feWatched = true;
    var t = null;
    function run() { t = null; try { evaluate(root); } catch (e) { note('evaluate error: ' + e.message); } }
    new MutationObserver(function () { if (!t) t = setTimeout(run, 50); })
      .observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: [STEP_ATTR] });
    run();
  }
  function waitShadow(host, n) {
    if (host.shadowRoot) return watchRoot(host.shadowRoot);
    if (n >= 60) { note('no open shadowRoot'); return; }
    setTimeout(function () { waitShadow(host, n + 1); }, 500);
  }
  function scan() {
    var hosts = document.getElementsByTagName(FORMS_HOST_TAG);
    for (var i = 0; i < hosts.length; i++) if (!hosts[i].__feHost) { hosts[i].__feHost = true; waitShadow(hosts[i], 0); }
  }
  if (ZERO_CLICK) {
    try {
      scan();
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.localName === FORMS_HOST_TAG || (n.firstElementChild && n.getElementsByTagName(FORMS_HOST_TAG).length))) { scan(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) { note('watch init failed: ' + e.message); }
  }

  api.watchRoot = watchRoot;                     // 仅供验收：给合成的 shadowRoot 挂监听
})();
